import { AccordionHeader } from "./AccordionHeader";
import { AccordionPanel } from "./AccordionPanel";
import { forwardRef } from "react";
import { Disclosure } from "../../disclosure";
import { H1, H2, H3, H4, H5, H6 } from "../../typography";
import { mergeProps, useEventCallback } from "../../shared";
import { useAccordionContext } from "./AccordionContext";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultElement = "div";

function isHeading(type) {
  return type === H1 || type === H2 || type === H3 || type === H4 || type === H5 || type === H6;
}

export function InnerAccordionItem({
  forwardedRef,
  item: {
    header,
    id,
    key,
    panel
  },
  ...rest
}) {
  const {
    expandedKeys,
    onToggle
  } = useAccordionContext();
  const handleOpenChange = useEventCallback(event => {
    onToggle(event, key);
  });
  const {
    elementType: headerElementType,
    props: headerProps,
    ref: headerRef
  } = header;
  const {
    elementType: PanelType = AccordionPanel,
    ref: panelRef,
    props: panelProps
  } = panel; // If the provided header element is an heading component, then use the accordion default AccordionHeader component and the type of the provided heading component as the heading type.
  // Otherwise, render the provided custom component and let it handle the heading type.

  const [HeaderType, headingType] = isHeading(headerElementType) ? [AccordionHeader, headerElementType] : [headerElementType, undefined];
  return /*#__PURE__*/_jsxs(Disclosure, { ...mergeProps(rest, {
      id,
      onOpenChange: handleOpenChange,
      open: expandedKeys.includes(key),
      ref: forwardedRef
    }),
    children: [/*#__PURE__*/_jsx(HeaderType, { ...headerProps,
      header: {
        headingType,
        key
      },
      ref: headerRef
    }), /*#__PURE__*/_jsx(PanelType, { ...panelProps,
      panel: {
        key
      },
      ref: panelRef
    })]
  });
}
InnerAccordionItem.defaultElement = DefaultElement;
export const AccordionItem = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerAccordionItem, { ...props,
  forwardedRef: ref
}));